import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** Cover width segmented control (preview-only), bound to the design context. */
export const CreateShowcaseDesignCoverWidthRow = memo(() => {
  const { coverWidthOptions, selectedCoverWidthOption, handleSelectCoverWidth } = useCreateShowcaseDesign();

  return (
    <SegmentedControlRow
      data-testid="CREATE_COLLECTION_LINK_DESIGN_COVER_WIDTH_ROW"
      label="Cover width"
      onSelect={handleSelectCoverWidth}
      options={coverWidthOptions}
      selectedOption={selectedCoverWidthOption}
    />
  );
});

CreateShowcaseDesignCoverWidthRow.displayName = 'CreateShowcaseDesignCoverWidthRow';
